import { render, staticRenderFns } from "./ExplicitConsents.vue?vue&type=template&id=40bf5b86&scoped=true&"
import script from "./ExplicitConsents.vue?vue&type=script&lang=js&"
export * from "./ExplicitConsents.vue?vue&type=script&lang=js&"
import style0 from "./ExplicitConsents.vue?vue&type=style&index=0&id=40bf5b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bf5b86",
  null
  
)

export default component.exports